import InexCard from "../InexCard";
import { Box, Typography } from "@mui/material";
import RainbowDivider from "../misc/RainbowDivider";
import React from "react";

import { HeadsetOutlined, TvRounded } from "@mui/icons-material";
import moment from "moment";
import { useNavigate } from "react-router";
import { VisibilityOutlined } from "@mui/icons-material";

const PodcastCard = ({ product }) => {
  const date = React.useMemo(() => {
    return moment(product.dateSortie);
  }, [product]);

  const navigate = useNavigate();

  return (
    <InexCard
      onClick={() => {
        navigate("/video-podcast/" + product.slug);
      }}
      sx={{
        padding: 0,
        paddingTop: 0,
        paddingBottom: 0,
        display: "flex",
        flexDirection: "column",
        height: "100%",
        minHeight: "100%",
        userSelect: "none",
        flexGrow: 1,
        backgroundColor: "transparent",
        boxShadow: "none",
        transition: "transform 0.2s",
        "&:hover": {
          transform: "scale(1.05)",
          cursor: "pointer",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          overflow: "hidden",
          position: "relative",
          //aspectRatio: 297 / 432,
          "& > img": {
            objectFit: "cover",
            width: "100%",
            minHeight: 200,
            height: "100%",
          },
          backgroundColor: "#ffffffbb",
        }}
      >
        <img
          src={`https://medias.inrees.com/img/pro/audiovisuel/haut_${product?.id}.jpg`}
          alt={"magazineImage"}
        />
        {/*{product?.category && (*/}
        {/*  <CategoryTag*/}
        {/*    category={product?.category}*/}
        {/*    sx={{*/}
        {/*      position: "absolute",*/}
        {/*      top: 0,*/}
        {/*      left: 0,*/}
        {/*    }}*/}
        {/*  />*/}
        {/*)}*/}
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            width: "100%",
            left: 0,
            padding: "15px",
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "column",
            paddingTop: "140px",
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.85) 100%)",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              flexGrow: 1,
              mt: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Branding SemiBold",
                  fontSize: "18px",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  color: "#ffffffbb",
                }}
              >
                {date.locale("fr").format("D MMMM YYYY")}
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Branding SemiBold",
                  fontSize: "18px",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  color: "white",
                  verticalAlign: "top",
                  fontWeight: "bold",
                  "&:hover": {
                    textDecoration: "underline",
                    cursor: "pointer",
                  },
                }}
              >
                {product.titre}
              </Typography>
            </Box>
            <Box
              sx={{
                mt: 1,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-start",
                color: "#A5D0C9",
              }}
            >
              <TvRounded
                sx={{
                  color: "#A5D0C9",
                }}
              />
              <Typography
                sx={{
                  marginLeft: 1,
                  marginRight: 2,
                  color: "#A5D0C9",
                  fontWeight: "bold",
                }}
              >
                Regarder
              </Typography>

              <HeadsetOutlined
                sx={{
                  color: "#A5D0C9",
                  marginRight: 1,
                }}
              />
              <Typography
                sx={{
                  color: "#A5D0C9",
                  fontWeight: "bold",
                }}
              >
                Écouter
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <RainbowDivider
        sx={{
          zIndex: 1,
          height: "3px",
        }}
      />
    </InexCard>
  );
};

export default PodcastCard;
